import { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';

const navLinks = [
  { label: 'Inicio', href: '/' },
  { label: 'Nosotros', href: '/nosotros' },
  { label: 'Productos', href: '/productos' },
  { label: 'Catálogo', href: '/catalogo' },
  { label: 'Servicios', href: '/servicios' },
  { label: 'Contacto', href: '/contacto' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMobileNav = () => {
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-950/95 backdrop-blur-md border-b border-primary-900/50'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 md:h-20 flex items-center justify-between">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center gap-3 cursor-pointer whitespace-nowrap"
          onClick={() => setMenuOpen(false)}
        >
          <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500">
            <i className="ri-flask-line text-white text-xl"></i>
          </div>
          <div className="flex flex-col leading-tight">
            <span className="font-heading font-700 text-base md:text-lg text-white tracking-wider uppercase">
              Poly Alphas
            </span>
            <span className="text-accent-400 text-xs font-500 tracking-widest uppercase">
              Chemicals C.A.
            </span>
          </div>
        </Link>

        {/* Desktop links */}
        <ul className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const isActive = pathname === link.href;
            return (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className={`px-4 py-2 text-sm font-500 tracking-wide rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap ${
                    isActive
                      ? 'text-primary-400 bg-primary-500/10'
                      : 'text-foreground-300 hover:text-white hover:bg-white/5'
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            );
          })}
        </ul>

        {/* CTA */}
        <Link
          to="/contacto"
          className="hidden md:flex items-center gap-2 px-5 py-2 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm font-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-mail-send-line"></i>
          Contáctanos
        </Link>

        {/* Hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-background-950/98 backdrop-blur-md border-t border-primary-900/40 px-4 pb-4">
          {navLinks.map((link) => {
            const isActive = pathname === link.href;
            return (
              <Link
                key={link.href}
                to={link.href}
                onClick={handleMobileNav}
                className={`block w-full text-left px-3 py-3 rounded-md transition-all text-sm font-500 cursor-pointer ${
                  isActive
                    ? 'text-primary-400 bg-primary-500/10'
                    : 'text-foreground-300 hover:text-white hover:bg-white/5'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
          <Link
            to="/contacto"
            onClick={handleMobileNav}
            className="mt-2 block w-full text-center py-3 rounded-md bg-primary-500 text-white text-sm font-600 cursor-pointer whitespace-nowrap"
          >
            Contáctanos
          </Link>
        </div>
      )}
    </nav>
  );
}